import { useRouter } from 'next/router';
import styles from './index.module.scss';
import NextImage from '@/components/NextImage';

export default function FixedIcon() {
    const { locale } = useRouter();

    return (
        <div className={`${styles.fixedIcon} consultation-fixed-icon`}>
            <a className="icon-box" href={`https://energy.ecoflow.com/${locale}/consultation`} target="_blank" rel="noreferrer">
                {locale === 'de' && <NextImage src={require('@publicLocal/consultation/fixed_icon_de.png')} alt="consultation" aria-label="consultation" />}
                {locale !== 'de' && <NextImage src={require('@publicLocal/consultation/fixed_icon.png')} alt="consultation" aria-label="consultation" />}
            </a>
        </div>
    );
}
